import {CurrentUser, currentUserClient} from 'common/report/queries/app-api/user-metadata-client';
import {ApiSingleValueResource} from 'common/util/model-resource/api-resource';

export {CurrentUser};

export class CurrentUserResource extends ApiSingleValueResource<CurrentUser> {
  apiClient = currentUserClient;
}
